import React, { useState } from 'react';
import { getBearerToken } from '../utils/Apis';
import { useLocation, useParams } from 'react-router-dom';
import { Parser } from 'html-to-react';
import { Box, Paper, CircularProgress, Typography, Stack } from '@mui/material';

const OAuth = () => {
  const htmlParser = new Parser();
  const { _id } = useParams();
  const location = useLocation();
  const location_code = location.search.split('=')[1];
  const [data, setdata] = useState('');

  React.useEffect(() => { fetch_users(); /* eslint-disable-next-line */ }, []);

  const fetch_users = async () => {
    getBearerToken('oauth_authorize/' + location_code).then((result) => {
      if (result.error === 0) setdata(result.data);
    });
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: 'background.default', position: 'relative', p: 3 }}>
      <div className="aurora" />
      <div className="grid-veil" />
      <Paper
        elevation={0}
        className="rise-in"
        sx={{
          position: 'relative', zIndex: 1, width: '100%', maxWidth: 520, p: { xs: 3, sm: 5 }, borderRadius: 4,
          background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.12)',
          backdropFilter: 'blur(18px)', WebkitBackdropFilter: 'blur(18px)', color: 'text.primary',
        }}
      >
        {data ? (
          htmlParser.parse(data)
        ) : (
          <Stack alignItems="center" spacing={2}>
            <CircularProgress sx={{ color: '#38bdf8' }} />
            <Typography color="text.secondary">Connecting your Zoom account…</Typography>
          </Stack>
        )}
      </Paper>
    </Box>
  );
};

export default OAuth;
